import React from 'react';
import Icon from '../../../components/AppIcon';

const EmployeeCodeInput = ({ 
  value = '', 
  maxLength = 6, 
  showValue = false,
  placeholder = "Mitarbeitercode eingeben",
  className = '',
  compact = false
}) => {
  const displayValue = showValue ? value : '•'?.repeat(value?.length);
  const remainingDots = maxLength - value?.length;

  return (
    <div className={`bg-card border-2 border-border rounded-xl ${compact ? 'p-4' : 'p-6'} ${className}`}>
      <div className="text-center mb-4">
        <Icon name="User" size={32} className="text-primary mx-auto mb-2" />
        <h2 className={`${compact ? 'text-base' : 'text-lg'} font-medium text-text-primary`}>{placeholder}</h2>
      </div>
      <div className="flex justify-center items-center space-x-2 min-h-[60px]">
        <div className={`flex ${compact ? 'space-x-2' : 'space-x-3'}`}>
          {Array.from({ length: maxLength })?.map((_, index) => (
            <div
              key={index}
              className={`${compact ? 'w-3.5 h-3.5' : 'w-4 h-4'} rounded-full border-2 flex items-center justify-center transition-all duration-200 ${
                index < value?.length
                  ? 'bg-primary border-primary' :'bg-transparent border-border'
              }`}
            >
              {index < value?.length && (
                <div className={`${compact ? 'w-1.5 h-1.5' : 'w-2 h-2'} bg-primary-foreground rounded-full`} />
              )}
            </div>
          ))}
        </div>
      </div>
      <div className="text-center mt-4">
        <p className={`${compact ? 'text-xs' : 'text-sm'} text-text-secondary`}>
          {value?.length === 0 
            ? "Zahlen tippen, um den Code einzugeben" 
            : `${value?.length} von ${maxLength} Ziffern eingegeben`}
        </p>
      </div>
    </div>
  );
};

export default EmployeeCodeInput;